import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  margin-bottom: 15px;

  .slider-container {
    margin-bottom: 3px;
    position: relative;
  }

  /* Position the dots step container */
  .rc-slider-step {
    width: calc(100% - 16px); /* Reduce width to add spacing on edges */
    left: 8px; /* Offset from left edge */
    top: 35%;
  }

  /* Add transitions for the dots */
  .rc-slider-dot {
    transition: background-color 0.1s ease;
  }

  /* Add smooth animation to the track */
  .rc-slider-track {
    transition: all 0.1s ease;
  }

  /* Make the handle have a larger hover area */
  .rc-slider-handle {
    cursor: pointer;
    transition: all 0.1s ease, transform 0.2s ease-out !important;

    &:hover {
      transform: scale(1.1);
    }
  }

  /* Styles for the temporary value label */
  .temp-value-container {
    position: absolute;
    bottom: -31px;
    display: flex;
    z-index: 10;
    pointer-events: none;
    transition: all 0.1s ease;
  }

  .temp-value-label {
    background-color: var(--menu-color-fullscreen, #3a3a3a);
    color: var(--grey-0);
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    box-shadow: var(--light-drop-shadow);
    white-space: nowrap;
    transition: transform 0.2s ease-out;
    transform-origin: center bottom;
  }
`;
